export enum ExportDataType {
    TaskNotes = 'TaskNotes',
    OccasionalSlots = 'OccasionalSlots',
    RegularSlots = 'RegularSlots',
    Absences = 'Absences',
    Parents = 'Parents',
    Works = 'Works',
    Staffs = 'Staffs',
    Daycares = 'Daycares',
    Trustees = 'Trustees',
    Childs = 'Childs',
    Events = 'Events',
    Calendar = 'Calendar',
    EventPresence = 'EventPresence',
    MealDay = 'MealDay'
}
